import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TurnstileComponent } from "src/app/core/ui/turnstile/turnstile.component";
import { AuthService } from "../../services/auth/auth.service";
import { SUBSCRIPTION_MODULE_CONFIG } from "../../subscription.token";

@Component({
  selector: "app-forgot-password",
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, TurnstileComponent],
  templateUrl: "./forgot-password.component.html",
  styleUrl: "./forgot-password.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordPageComponent {
  private fb = inject(FormBuilder);
  private auth = inject(AuthService);
  private moduleConfig = inject(SUBSCRIPTION_MODULE_CONFIG);

  captchaEnabled = this.moduleConfig.auth.captcha.type === "turnstile";

  busy = signal(false);
  error = signal<string | null>(null);
  sent = signal(false);

  form: FormGroup = this.fb.group({
    email: [null, [Validators.required, Validators.email]],
    captchaToken: [null, this.captchaEnabled ? Validators.required : null],
  });

  submit() {
    if (!this.form.valid) return;
    this.error.set(null);
    this.busy.set(true);
    const { email, captchaToken } = this.form.value;
    this.auth.forgotPassword(email, captchaToken).subscribe({
      next: () => this.sent.set(true),
      error: (err) => this.error.set(err?.message ?? "Failed to send reset email"),
    }).add(() => this.busy.set(false));
  }
}
